<button appTrackEvent="GenerateReportClicked" [eventProperties]="{dimensionName: getPerspectiveName(), reportPath: this.reportPath(), filters: this.filterDimensions()}" (click)="generateReport()">
  <span>
    Generate report
  </span>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <use [attr.xlink:href]="SvgSpriteIcon.ArrowForward"></use>
  </svg>
</button>
